import { createSlice } from '@reduxjs/toolkit'
export const appReducer = createSlice({
    name: 'appReducer',
    initialState: {
        lang: 'en',
        user: {},
        isuserlogged: undefined,
        showDialog: false,

        showErrorToast: {
            flag: false,
            content: '',
        },
        showDeleteDialog: {
            show: false,
            url: '',
        },
        cartCount: 0,
        showSplash: true,
        storeMetaData: {},
        storeData: [],
    },
    reducers: {
        setUserLoggedStatus: (state, action) => {
            state.isuserlogged = action.payload
        },
        setShowDialog: (state, action) => {
            state.showDialog = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setShowDeleteDialog: (state, action) => {
            state.showDeleteDialog = action.payload;
        },
        setErrorToast: (state, action) => {
            state.showErrorToast = action.payload;
        },

        setShowSplash: (state, action) => {
            state.showSplash = action.payload;
        },
        setStoreMetaData: (state, action) => {
            state.storeMetaData = action.payload;
        },
        setStoreData: (state, action) => {
            state.storeData = action.payload;
        },
        setCartCount: (state, action) => {
            state.cartCount = action.payload;
        },
    }
})
export const { setCartCount, setUser, setUserLoggedStatus, setShowDialog, setShowDeleteDialog, setErrorToast, setShowSplash, setStoreMetaData, setStoreData } = appReducer.actions

export default appReducer.reducer